module.exports = __webpack_public_path__ + "img/07_Learn_More.d31e9b2e.jpg";